import {Activity, ActivityConstructorParams, NavigationOptions, OnNavigateOptions} from "./Activity";
import {EL} from "../util/DomUtils";
import {DomWindow} from "../DomWindow";
import {IHierarchy} from "../lib/hierarchy";
import {UiContext} from "../util/UiContext";
import {registerClass} from "../Plugin";
import {RegistryLookupError} from "../core/IResolver";

export class MessageActivity extends Activity {
    constructor(public title: string, public message?: string, public button?: HTMLElement, public icon: string | HTMLElement = 'ℹ️') {
        super({});
    }
    async initUI() {
        await super.initUI();
        this.contentEl.style.display = 'flex';
        this.contentEl.style.flexDirection = 'column';
        this.contentEl.style.justifyContent = 'center';
        this.contentEl.style.textAlign = 'center';

        this.contentEl.replaceChildren(
            EL('h1', {style:{fontSize:'400%',margin:'10px'}}, this.icon),
            EL('h2', {style:{margin:'10px'}, innerHTML: UiContext.instance.markdown.render(this.title, true)}),
            EL('p', {innerHTML: UiContext.instance.markdown.render(this.message || '', true)}),
            EL('p', {}, this.button),
        );
    }
    async onNavigate(url: URL, options: OnNavigateOptions): Promise<void> {
        await super.onNavigate(url, options);
    }
}
@registerClass(Activity.activityTypes)
export class LegacyDomWindowWrapperActivity extends Activity {
    _innerNavigate: (url: URL, navigationOptions?: NavigationOptions) => Promise<void>;
    _innerClose: Function;
    readonly wrappedWindowConstructor;
    wrappedWindow: DomWindow;
    constructor(public params: ActivityConstructorParams) {
        super(params);

        const inner = params.activityUrl.searchParams.get('inner').toLowerCase();
        for(const type of DomWindow.windowTypes.flatCollect()) {
            if (type.name.toLowerCase() == inner || type.protocol?.toLowerCase() === inner) {
                this.wrappedWindowConstructor = type;
            }
        }
        if (!this.wrappedWindowConstructor)
            throw new RegistryLookupError("window type", inner);
    }
    get children(): IHierarchy[] {
        return [this.wrappedWindow];
    }
    useShadowRoot() {
        return false;
    }
    async initUI() {
        if (this.wrappedWindow) throw new Error("illegal state");
        this.wrappedWindow = new ('getConstructor' in this.wrappedWindowConstructor ? await this.wrappedWindowConstructor.getConstructor() : this.wrappedWindowConstructor)();
        this.dtor.use(this.wrappedWindow);

        this.rootContainerEl.replaceChildren(this.wrappedWindow.contentEl, this.wrappedWindow.footerEl);
        this._innerNavigate = this.wrappedWindow.navigate.bind(this.wrappedWindow);
        this.wrappedWindow.navigate = async (url: URL, navigationOptions?: NavigationOptions) => {
            await super.navigate(url, navigationOptions);
        }
        this.wrappedWindow.saveWinPos = () => {};
        this._innerClose = this.wrappedWindow.close.bind(this.wrappedWindow);
        this.wrappedWindow.close = () => this.parent?.close();
        this.wrappedWindow.focus = () => undefined;
        this.wrappedWindow.setTitle = (title) => {
            this.setTitle(title);
        }
        this.setTitle(this.wrappedWindow.title);
        this.wrappedWindow.updateButtons = () => {
            this.setButtons(this.wrappedWindow.getButtons());
        }
        this.setButtons(this.wrappedWindow.getButtons());

        if (this.wrappedWindow.id && this.wrappedWindow.id.startsWith("tmpwnd")) localStorage.removeItem("winPos_"+this.wrappedWindow.id);
        this.wrappedWindow.container.remove();
        if (DomWindow.current === this.wrappedWindow) DomWindow.current = this.parent instanceof DomWindow ? this.parent : null;
        this.wrappedWindow.container = { remove() {},  } as any;  // HACK to make close() happy
        delete DomWindow.windows[this.wrappedWindow.id];
        await this.wrappedWindow.initUI();
        await super.initUI();
    }

    async onNavigate(url: URL, options: OnNavigateOptions): Promise<void> {
        await this._innerNavigate(url, options);
        await super.onNavigate(url, options);
    }
    afterResize() {
        super.afterResize();
        this.wrappedWindow?.afterResize();
    }

    async onBeforeNavigate(url: URL, options: OnNavigateOptions): Promise<void> {
    }
    async onBeforeUnload(): Promise<void> {
        if (!this._innerClose) return;
        const old = this.wrappedWindow;
        try {
            this.wrappedWindow = null;
            this._innerClose();
        } catch(e) {
            this.wrappedWindow = old;
            throw e;
        }
    }

}